export default __webpack_public_path__ + "static/media/bl10.d8981652.png";